module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agentinfo"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("代理管理")]), _vm._v(" "), (!_vm.agent_id) ? _c('div', {
    staticClass: "contentcard",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("代理ID有误，请从上级页面重新进入")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "agentlist"
    }
  }, [_vm._v("返回")])], 1) : _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px",
      "text-align": "right",
      "font-weight": "700",
      "margin-right": "10px"
    }
  }, [_vm._v("用户ID")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.agent_info.user_id))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px",
      "text-align": "right",
      "font-weight": "700",
      "margin-right": "10px"
    }
  }, [_vm._v("微信昵称")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.agent_info.nick_name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px",
      "text-align": "right",
      "font-weight": "700",
      "margin-right": "10px"
    }
  }, [_vm._v("微信头像")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.agent_info.UIC_User.avatar_url,
      "height": "140"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px",
      "text-align": "right",
      "font-weight": "700",
      "margin-right": "10px"
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.agent_info.phone_number))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px",
      "text-align": "right",
      "font-weight": "700",
      "margin-right": "10px"
    }
  }, [_vm._v("等级")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "defaultValue": _vm.agent_info.level
    },
    model: {
      value: (_vm.agent_info.level),
      callback: function($$v) {
        _vm.$set(_vm.agent_info, "level", $$v)
      },
      expression: "agent_info.level"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("皇冠会员")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("钻石会员")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px",
      "text-align": "right",
      "font-weight": "700",
      "margin-right": "10px"
    }
  }, [_vm._v("上级代理")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入上级ID",
      "disabled": _vm.agent_info.level == '1'
    },
    model: {
      value: (_vm.agent_info.superior_id),
      callback: function($$v) {
        _vm.$set(_vm.agent_info, "superior_id", $$v)
      },
      expression: "agent_info.superior_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px",
      "text-align": "right",
      "font-weight": "700",
      "margin-right": "10px"
    }
  }, [_vm._v("平台来源")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "defaultValue": _vm.agent_info.user_from_platform
    },
    model: {
      value: (_vm.agent_info.user_from_platform),
      callback: function($$v) {
        _vm.$set(_vm.agent_info, "user_from_platform", $$v)
      },
      expression: "agent_info.user_from_platform"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("微信")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("支付宝")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("百度")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px",
      "text-align": "right",
      "font-weight": "700",
      "margin-right": "10px"
    }
  }, [_vm._v("来源app")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "defaultValue": _vm.agent_info.user_from_app
    },
    model: {
      value: (_vm.agent_info.user_from_app),
      callback: function($$v) {
        _vm.$set(_vm.agent_info, "user_from_app", $$v)
      },
      expression: "agent_info.user_from_app"
    }
  }, _vm._l((_vm.app_name), function(app, inde) {
    return _c('a-select-option', {
      key: inde,
      attrs: {
        "value": app.id
      }
    }, [_vm._v(_vm._s(app.app_name))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px",
      "text-align": "right",
      "font-weight": "700",
      "margin-right": "10px"
    }
  }, [_vm._v("是否审核通过")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "defaultChecked": _vm.agent_info.reviewed
    },
    model: {
      value: (_vm.agent_info.reviewed),
      callback: function($$v) {
        _vm.$set(_vm.agent_info, "reviewed", $$v)
      },
      expression: "agent_info.reviewed"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "checkedChildren",
      "type": "check"
    },
    slot: "checkedChildren"
  }), _vm._v(" "), _c('a-icon', {
    attrs: {
      "slot": "unCheckedChildren",
      "type": "close"
    },
    slot: "unCheckedChildren"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px",
      "font-size": "12px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.submitbtn
    }
  }, [_vm._v("确认")])], 1)])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-733e73be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/agentmanagement/agentinfo/index.vue
// module id = 2388
// module chunks = 1